import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Dealer.UploadUiFile.IRequest;
type Response = Api.Core.Dealer.UploadUiFile.IResponse;
type Headers = Api.Core.Dealer.UploadUiFile.IHeaders;
const apiDealerUploadUiFilePath = '/api/DealerManagement/Dealer/:id/UploadUiFile';
export default async function dealerUploadUiFileApi(id: number, request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiDealerUploadUiFilePath, { id }),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
